module.exports = __webpack_public_path__ + "media/components/spaces/comment-sidebar-panel-1-ac024282c55d7eb0df273cec0ce92ca4.png";